module.exports = __webpack_public_path__ + "static/media/vision.c9842ec7.svg";